export const initialState = {
    feedResult: [],
    startSessionTime: {}
}